import Icon from "../../../Icon";

type CalltoActionProps = {
    text: string;
};

/**
 *
 * A card CallToAction
 */
export const CallToAction = ({ text }: CalltoActionProps) => {
    return text ? (
        <div className="callToAction" data-testid="callToAction">
            {text}
            <Icon type="chevron" />
        </div>
    ) : null;
};

export default CallToAction;
